/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_500_Meta_TitleInputs */

const ja_error_500_meta_title = /** @type {(inputs: Error_500_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN エラー 500`)
};

const en_error_500_meta_title = /** @type {(inputs: Error_500_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN Error 500`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN Error 500" |
*
* @param {Error_500_Meta_TitleInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const error_500_meta_title = /** @type {((inputs?: Error_500_Meta_TitleInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_500_Meta_TitleInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_error_500_meta_title(inputs)
	return en_error_500_meta_title(inputs)
});